import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../../images/icon-source.png';
const _hoisted_1 = {
  class: "source-block rounded-lg overflow-hidden"
};
const _hoisted_2 = {
  class: "source-top flex items-center justify-between"
};
const _hoisted_3 = {
  class: "flex items-center flex-wrap"
};
const _hoisted_4 = {
  class: "max-w-[450px] truncate"
};
const _hoisted_5 = {
  class: "primary-text"
};
const _hoisted_6 = {
  class: "max-w-[450px] truncate font-normal"
};
import { ref } from 'vue';
import { ArrowDown } from '@element-plus/icons-vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'SourceBlock',
  props: {
    links: {}
  },
  setup(__props) {
    const props = __props;
    const isFold = ref(false);
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_link = _resolveComponent("el-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[3] || (_cache[3] = _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        class: "w-4 h-4 mr-[2px] block"
      }, null, -1)), _cache[4] || (_cache[4] = _createElementVNode("span", {
        class: "text-[#1D2129] text-sm"
      }, "信息来源链接：", -1)), _createElementVNode("div", _hoisted_4, [_cache[1] || (_cache[1] = _createTextVNode(" 来自 ", -1)), _createElementVNode("span", _hoisted_5, _toDisplayString(__props.links.length), 1), _cache[2] || (_cache[2] = _createTextVNode(" 个链接分析后生成 ", -1))])]), _createElementVNode("div", {
        class: "btn flex items-center cursor-pointer",
        onClick: _cache[0] || (_cache[0] = $event => isFold.value = !isFold.value)
      }, [_cache[5] || (_cache[5] = _createElementVNode("span", {
        class: "whitespace-nowrap"
      }, "展开", -1)), _createVNode(_component_el_icon, {
        class: _normalizeClass(["ml-1 transition-transform", {
          'rotate-180': isFold.value
        }])
      }, {
        default: _withCtx(() => [_createVNode(_unref(ArrowDown))]),
        _: 1
      }, 8, ["class"])])]), _createElementVNode("div", {
        class: _normalizeClass(["content", {
          'is-fold': isFold.value
        }])
      }, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.links, (link, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index
        }, [_createVNode(_component_el_link, {
          type: "primary",
          href: link,
          target: "_blank"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, _toDisplayString(link), 1)]),
          _: 2
        }, 1032, ["href"])]);
      }), 128))])], 2)]);
    };
  }
});